import CardComponent from './CardComponent';

export class Booking extends CardComponent {}
